import React, { Component } from 'react'
import Cookie from 'react-cookies'

//Default imports
import Const from '../config/const'

//Actions imports
import {setLanguage} from "../actions/commands";

export default class LanguageSelector extends Component {
    constructor(props){
        super(props);
        this.handleClick = this.handleClick.bind(this)
    }
    handleClick(lang){
        setLanguage(lang.path)
    }
    render(){
        return (
            <div className="language-selector">
                <ul>
                    {Const.defaults.language_list.map( (lang, index) => {
                        return (
                            <li key={index}><button onClick={ () => this.handleClick(lang)} className={lang.path === Cookie.load(Const.hash.cookie_lang)?'selected':''}>{lang.title}</button></li>
                        )
                    })}
                </ul>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/laguage.js